/**
 * Stockist Control
 * Ensures the store locator list refreshes to the default state 
 * when the search input is cleared via keyboard or the 'x' button.
 */
(function () {
  // Prevent double initialisation
  if (window.__aafStockistControlInitialized) return;
  window.__aafStockistControlInitialized = true;

  const init = () => {
    let attempts = 0;
    const maxAttempts = 100; // 10 seconds total
    const checkInterval = 100;

    const poll = setInterval(() => {
      attempts++;

      const widget = window.Stockist && window.Stockist.__widget;
      const input = widget?._form?._input;
      const form = widget?._form?._element;
      const client = widget?._client;

      // Wait until all necessary internal Stockist components are ready
      if (input && form && client) {
        clearInterval(poll);
        attachHandlers(input, form, client);
      } else if (attempts >= maxAttempts) {
        clearInterval(poll);
      }
    }, checkInterval);
  };

  /**
   * Binds listeners to the search input and form
   */
  const attachHandlers = (input, form, client) => {
    let lastValue = input.value.trim();

    const triggerRefresh = () => {
      if (typeof client._invokeInitialQuery === 'function') {
        client._invokeInitialQuery();
      }
      lastValue = '';
    };

    // Handle keyboard clearing (backspace/delete) and native clear events
    const onInputChange = () => {
      const currentValue = input.value.trim();
      if (lastValue !== '' && currentValue === '') {
        triggerRefresh();
      }
      lastValue = currentValue;
    };

    input.addEventListener('input', onInputChange);
    input.addEventListener('search', onInputChange); // Native x button support

    // Handle Stockist's custom 'x' button via event delegation
    form.addEventListener('click', (event) => {
      if (event.target.closest('.stockist-clear-search-button')) {
        // Small buffer to let Stockist's internal logic clear the field first
        setTimeout(() => {
          if (input.value.trim() === '') {
            triggerRefresh();
          }
        }, 50);
      }
    });
  };

  // Initialise when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();